import { 
    Box,
    Typography,
} from "@mui/material";

import IntegrationCard from "components/IntegrationCard";

import { useSelector, useDispatch } from "react-redux";
    
import { third_party_constants } from "constants/third_party_constants";

function createData(id, profile, email, current_scopes, missing_scopes, actions) {
    return { id, profile, email, current_scopes, missing_scopes, actions };
}
  
const rowsGoogle = [
    createData('1', 'https://lh3.googleusercontent.com/a/AGNmyxbhzrpB-8qCc8Er7oeSEVCMy2VjeDJB4mIg9ftC=s96-c', 'meetingaggregator@gmail.com', [third_party_constants.google_calendar, third_party_constants.google_drive], [third_party_constants.google_meet], true),
    createData('2', 'https://lh3.googleusercontent.com/a/AGNmyxb3xU8tImOpL_OCE8Wmb3ohQYvpRzZSEzy2boh3=s96-c', 'teammoteio@gmail.com', [third_party_constants.google_meet], [third_party_constants.google_calendar, third_party_constants.google_drive], false),
];

const rowsMicrosoft = [];


const IntegrationsPage = () => {
    const dispatch = useDispatch();

    const allWorkspaces = useSelector(state => state.auth.user?.allWorkspaces);
    console.log("allWorkspaces", allWorkspaces);

    return (
        <Box display="flex" p="3rem" gap="1rem" justifyContent="left" alignItems="left" flexDirection="column">
            {/* TITLE */}
            <Typography variant="h4" fontWeight="bold">Your Integrations</Typography>

            {/* INTEGRATIONS */}
            <Box style={{ width: "80%" }}>
                {/* GOOGLE */}
                <IntegrationCard
                    integrationType="google"
                    data={rowsGoogle}
                />

                {/* MICROSOFT */}
                <IntegrationCard
                    integrationType="microsoft"
                    data={rowsMicrosoft}
                />
                
                {/* ZOOM */}
                {/* SLACK */}

            </Box>

            

        </Box>
    );
};

export default IntegrationsPage;